import { render, staticRenderFns } from "./YKHoliday.vue?vue&type=template&id=663004fc&scoped=true&"
import script from "./YKHoliday.vue?vue&type=script&lang=js&"
export * from "./YKHoliday.vue?vue&type=script&lang=js&"
import style0 from "./YKHoliday.vue?vue&type=style&index=0&id=663004fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663004fc",
  null
  
)

export default component.exports